// @flow
import {
  FETCH_VSHELF,
  FETCH_VSHELF_SUCCESS,
  FETCH_VSHELF_ERROR,
  NOTIFY_USER,
  UPDATE_VSKU_PURCHASE_COUNT,
  RESET_VSHELF,
} from "./types";
import type { Action, CartData } from "./types";

export const fetchVirtualShelf = (selectedPod: any, affiliateId:? string): Action => ({
  type: FETCH_VSHELF,
  payload: {selectedPod, affiliateId}
});

export const fetchVirtualShelfSuccess = (vShelfData: any): Action => ({
  type: FETCH_VSHELF_SUCCESS,
  payload: vShelfData
});

export const fetchVirtualShelfError = (error: any): Action => ({
  type: FETCH_VSHELF_ERROR,
  payload: error
});

export const notifyUser = (data: any): Action => ({
  type: NOTIFY_USER,
  payload: data
});

export const updateVSkuPurchareCount = (cartData: CartData): Action => ({
  type: UPDATE_VSKU_PURCHASE_COUNT,
  payload: cartData
});

export const resetVirtualShelf = (): Action => ({
  type: RESET_VSHELF,
});


